<template>
    <div class="mr-20">
        <button class="btn modify-button" @click="showModifyVersionModal">
            Modify version
        </button>
        <button class="btn activate-button ml-8" @click="versionLive()">
            Make version live
        </button>
        <ModifyVersionModal ref="modify-version-modal-component" />
        <MakeVersionLiveModal ref="MakeVersionLiveModal" />
    </div>
</template>
<script>
import ModifyVersionModal from "@/components/version-management/modify-version-modal.vue";
import MakeVersionLiveModal from "@/components/version-management/make-version-live-modal.vue";
import commonMixin from "./commonMixin";
export default {
    name: "version-controls",
    data() {
        return {
            studyData : {}
        };
    },
    components: {
        ModifyVersionModal,
        MakeVersionLiveModal
    },
    computed: {
        studyId() {
            return this.$route.params.studyId;
        }
    },
    mixins: [commonMixin],
    methods: {
        async showModifyVersionModal() {
          const isValid = await this.validatePendingApplyOperations(this.studyId);
          if(!isValid){
            return;
          }
          await this.$nextTick();
          this.$refs["modify-version-modal-component"].$refs["modify-version-modal"].show();
        },
        async versionLive() {
          try{
            const isValid = await this.validatePendingApplyOperations(this.studyId);
            if(!isValid){
              return;
            }
            const response = await this.$api.getStudyDataFact(this.studyId);
            this.studyData = response.body;

            if (this.studyData && this.studyData.canVersionLive) {
              this.$refs.MakeVersionLiveModal.show();
            } else {
              this.$toastr.error("You have already made this version live, please make modifications before making live again.");
            }
          } catch (error) {
            this.$toastr.error("Error while attempting to make version live, please try again later.");
          }
        },
    }
}
</script>

<style scoped lang="scss">

.btn {
  height: 32px;
  padding-top: 3px;
}

.activate-button {
  background-color: #4c8ce4;
  color: #ffffff;
}

.modify-button {
  background-color: rgba(76, 140, 228, 0.08);
  color: #9ac4ff;
}
</style>
